<template>
  <div class="header-client">
    <div @click="changeOrder">
      <label :for="column">{{ $t("b2c." + column) }}</label>
      <i
        class="fa"
        :class="{
          'fa-arrow-up': isAscending,
          'fa-arrow-down': isAscending === false,
          'fa-minus': isAscending === null,
        }"
      ></i>
    </div>
  </div>
</template>

<script>
export default {
  props: ["column", "filterVal", "valid", "isAscending", "validator"],
  methods: {
    changeOrder: function () {
      let orderBy = {
        column: this.column,
        isAscending: !this.isAscending,
      };
      this.$emit("updateOrderBy", orderBy);
    },
  },
};
</script>
<style scoped>
.fa-minus,
.fa-arrow-up,
.fa-arrow-down {
  /*   position: absolute;
  right: 5px;
  bottom: 5px; */
  float: right;
}
.search-icon {
  position: absolute;
  right: 5px;
  bottom: 6px;
  color: hsla(0, 0%, 0%, 0.4);
}
.header-client:focus-within .search-icon {
  display: none;
}
.header-client {
  position: relative;
}
.header-client label {
  float: left;
  cursor: pointer;
  /*   position: absolute;
  transform: translateY(0px);
  transition: transform ease 0.3s, font-size ease-in-out 0.2s;
  left: 1px;
  cursor: text; */
}
.header-client .fa {
  cursor: pointer;
}
/* .header-client-input:valid + label,
.calendar-open,
.header-client:focus-within > label {
  transform: translateY(-15px);
  font-size: 12px;
} */
.header-client > input {
  width: 100%;
  padding-right: 1.5em;
}

.header > input:focus {
  border-color: #fff;
  border-bottom: 1px solid;
}
</style>
